import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Location } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { GET_MOBIOFFICE_UI_ApplicationDetails, GET_MOBIOFFICE_UI_User, LoaderService, MobiOfficeUIState, RightsService, SideNavService, UnSubscriber, select_MOUI_User } from "@mobi-office-ui";
import { Store, select } from "@ngrx/store";
import { distinctUntilChanged, map, Observable } from "rxjs";

const AVOID_PREFIX_URLS: string[] = ["/", "/login"];

@Component({
  selector: "mobi-office-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: false,
})
export class AppComponent extends UnSubscriber implements OnInit, AfterViewInit {
  constructor(
    private sideNavService: SideNavService,
    private router: Router,
    private loaderService: LoaderService,
    private cdRef: ChangeDetectorRef,
    private store: Store<MobiOfficeUIState>,
    private location: Location,
    private rightsService: RightsService,
    private breakpointObserver: BreakpointObserver
  ) {
    super();
  }

  ngOnInit(): void {
    //Spinner Handler
    this.loaderService.getSpinnerObserver().subscribe(status => {
      this.showSpinner = status === "start";
      this.cdRef.detectChanges();
    });

    // Recall user info of token is available
    const token = sessionStorage.getItem("token");
    if (token) this.store.dispatch(GET_MOBIOFFICE_UI_User());

    // Router Handler
    this.routerHandler();

    this.breakpointChanged();
  }

  ngAfterViewInit(): void {
    // Set Dynamic mat drawer
    this.sideNavService.setPanel(this.sidePanel);
    this.sideNavService.setContentVcf(this.vcf);

    // Get Application info
    this.store.dispatch(GET_MOBIOFFICE_UI_ApplicationDetails());
    this.userMain$ = this.store.pipe(select(select_MOUI_User)).pipe(map((userRes: any) => userRes));
  }

  showSpinner: boolean = false;
  @ViewChild("dynamicSideNav", { static: true }) private sidePanel!: MatSidenav;
  @ViewChild("dynamicSideNavContent", { static: true, read: ViewContainerRef }) private vcf!: ViewContainerRef;
  userMain$!: Observable<any>;
  toggleSideBar: boolean = false;
  toggleCompanyLogo: boolean = false;
  readonly breakpoints = Breakpoints;

  private breakpointChanged() {
    this.anotherSubscription = this.breakpointObserver
      .observe(["(max-width: 600px)", "(max-width: 1024px)", this.breakpoints.Handset, this.breakpoints.Small])
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        this.toggleCompanyLogo = this.breakpointObserver.isMatched("(max-width: 600px)");
      });
  }

  get avoidPrefix() {
    const currentUrl = this.router.url?.split("?")[0];
    return !!AVOID_PREFIX_URLS.find(el => el === currentUrl);
  }

  get isUserLoggedIn(): boolean {
    return !!sessionStorage.getItem("token");
  }

  get sideMenus$(): Observable<any> {
    return this.store.pipe(select(select_MOUI_User)).pipe(
      map((userRes: any) => {
        const { NestedMenu } = userRes?.UserInfo || {};
        return NestedMenu;
      })
    );
  }

  private routerHandler() {
    // Handle Router
    this.router.events.subscribe(res => {
      if (res instanceof NavigationStart) {
        setTimeout(async () => {
          if (res.navigationTrigger === "popstate" && !res.restoredState) {
            this.location.back();
            return;
          }
          const currentUrl = res.url;
          this.rightsService.setRightsSessionStorage(currentUrl);
        }, 0);
      }

      if (res instanceof NavigationEnd) {
        console.log("Navigation Ends");
        const currentUrl = res.url;
        this.rightsService.setRightsSessionStorage(currentUrl);
      }
    });
  }

  onTabChange(tab: any) {
    this.router.navigate([tab.URL]);
  }

  onLogoClick() {
    this.router.navigate(["/dashboard"]);
  }

  onLogOut() {
    sessionStorage.clear();
    window.location.reload();
  }
}
